// extracted by mini-css-extract-plugin
var _1 = "PdfViewerThumbnails-modulePdfViewerThumbnails___OnRR";
export { _1 as "PdfViewerThumbnails" }
